import type { InvalidationAction } from '../models/actions';

export const makeInvalidationAction = (
    details: Pick<InvalidationAction, 'kind'> & Partial<InvalidationAction>,
): InvalidationAction => {
    return {
        scope: 'inapp',
        ...details,
        $kind: 'invalidationAction',
        actionMetrics: {
            data: [],
            custom: {},
        },
    };
};
